<template>
    <div class="login-pos">
        <img class="login-pos__logo" src="@/assets/images/header/logo.png"/>
        <div class="login-pos__input-password">
            <b-form-input
                    type="text"
                    v-model="qrcode"
                    placeholder="Enter QR Code"
                    class="text-center"
            />
        </div>
        <div class="login-pos__button-login">
            <b-button @click="handleScanQrCode">Search</b-button>
        </div>
    </div>
</template>
<script>
    import lottoService from '@/services/lotto.service';
    import { singleTicket } from '@/resources/loto'
    export default {
        data() {
            return {
                qrcode: '',
              singleTicket
            }
        },
        methods: {
            handleScanQrCode() {
                lottoService.scanQrCode(this.qrcode).then((res) => {
                        if (res.status === 'success') {
                            // console.log("qr code",res.data.qr.bets.bet);
                            const bet = res.data.qr.bets.bet;
                            bet.forEach((item, i) => {
                                const main = item[0];
                                this.singleTicket.forEach((ticket, index) => {
                                    if (index === i) {
                                        ticket.forEach(ticket => ticket.active = main.includes(ticket.number) ? true : false)
                                    }
                                }) ;
                            });
                            this.$store.dispatch('addOrUpdateTickets', this.singleTicket);
                            this.$router.push('/lotto');

                        } else {
                            const message = res.message;
                            this.$bvToast.toast(message, {
                                title: 'Failed',
                                variant: 'danger',
                                solid: true,
                                autoHideDelay: 5000
                            })
                        }

                    },
                    () => this.$bvToast.toast('Scan QR CODE failed! Please try again', {
                        title: 'Failed',
                        variant: 'danger',
                        solid: true,
                        autoHideDelay: 5000
                    }));
            }
        }
    }
</script>
